export const TITLE_TEXT = 'Select how would you like to return it';
export const methods = [
  {
    value: '1',
    title: "Use Seel's return shipping label (USPS)",
    subTitle: 'The shipping fee will be deducted from your refund',
  },
  // {
  //   value: '2',
  //   title: 'Use your own preferred carrier',
  //   subTitle: "You'll pay for the shipping fee upon shipment",
  // },
];

export const MODAL_TITLE = 'Please confirm the dimensions of your package ';
export const MODAL_TIPS = 'Please make sure to provide accurate information below.';
export const ERROR_TIPS = 'Sorry, your package exceeds the USPS maximum limit for Seel-generated labels. Please choose \'Use your own preferred carrier\'.';

export const fields = [
  {
    label: 'What is the weight of your mail piece? (lb)',
    value: 'weightInLb',
    rules: [
      { required: true },
      {
        type: 'number', min: 0.01, max: 70, step: 0.01, precision: 2,
      },
    ],
  },
  {
    label: 'Length (in)',
    value: 'lengthInInch',
    rules: [
      { required: true },
      {
        type: 'number', min: 0, max: 108, step: 1,
      },
    ],
  },
  {
    label: 'Height (in)',
    value: 'heightInInch',
    rules: [
      { required: true },
      {
        type: 'number', min: 0, max: 108, step: 1,
      },
    ],
  },
  {
    label: 'Width (in)',
    value: 'widthInInch',
    rules: [
      { required: true },
      {
        type: 'number', min: 0, max: 108, step: 1,
      },
    ],
  },
];
